import { CommonService } from "./CommonService";
import { AuthService } from "./AuthService";
import { UsersService } from "./UsersService";
import { BoardService } from './BoardService';
import { SubscriptionService } from './Subscription';
import { ScheduleService } from "./ScheduleService";
import { StudentsService } from "./StudentsService";
import { ExitReasonService } from "./ExitReasonService";
import { SaveOfferService } from "./SaveOfferService";


export const teachersService = new CommonService('teacher');
export const levelsService = new CommonService('level');
export const stickersService = new CommonService('sticker');
export const stylesService = new CommonService('style');
export const studioService = new CommonService('studio');

export const scheduleService = new ScheduleService('schedule'); 
export const boardsService = new BoardService('board');
export const subscriptionsService = new SubscriptionService('subscription');
export const usersService = new UsersService();
export const studentsService = new StudentsService();
export const auth = new AuthService();

// Mounted at /exit-reasons in server/app.js, so the entity name is passed whole rather
// than pluralised by CommonService.
export const exitReasonService = new ExitReasonService('exit-reasons');

// Mounted at /save-offer in server/app.js (PR #106), singular and passed whole for the
// same reason as the entity above.
export const saveOfferService = new SaveOfferService('save-offer');
